// extracted by mini-css-extract-plugin
export var actions = "_qh-4";
export var item = "_qh-1";
export var price = "_qh-3";
export var quantity = "_qh-2";
export var table = "_qh-0";